import { createSlice } from '@reduxjs/toolkit';

const ArticleFolderDetailsDataSlice = createSlice({
    name: 'ArticleFolderDetailsData',
    initialState: '',
    reducers: {
        setArticleFolderDetailsData: (state, action) => {
            return action.payload;
        },
        resetArticleFolderDetailsData: (state) => {
            return null;
        },
    },
});

export const { setArticleFolderDetailsData, resetArticleFolderDetailsData } = ArticleFolderDetailsDataSlice.actions;
export default ArticleFolderDetailsDataSlice.reducer;